import { render, staticRenderFns } from "./disclaimer-checkout.vue?vue&type=template&id=f08cbec0&scoped=true"
import script from "./disclaimer-checkout.vue?vue&type=script&lang=js"
export * from "./disclaimer-checkout.vue?vue&type=script&lang=js"
import style0 from "./disclaimer-checkout.vue?vue&type=style&index=0&id=f08cbec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08cbec0",
  null
  
)

export default component.exports